import RelatedBillingsTaxiTaxiTableColumn from "./types/related-billings-taxi-taxi-table-column";
import billingsTranslationsHelper from "../../../../../languages/billings-translations.helper";

const createTableColumns = (): RelatedBillingsTaxiTaxiTableColumn[] => {
  const translations =
    billingsTranslationsHelper.getBillingsTranslations().relatedBillings
      .taxi_taxi.table;

  const tableColumns: RelatedBillingsTaxiTaxiTableColumn[] = [
    {
      header: "",
      title: "",
      accessor: "billingStatus",
      colSpan: 2,
    },
    {
      header: translations.headers.dateLabel,
      title: translations.headers.dateTitle,
      accessor: "date",
      colSpan: 6,
    },
    {
      header: translations.headers.internalOrderIdLabel,
      title: translations.headers.internalOrderIdTitle,
      accessor: "internalOrderId",
      colSpan: 4,
    },
    {
      header: translations.headers.companyNameLabel,
      title: translations.headers.companyNameTitle,
      accessor: "companyName",
      colSpan: 7,
    },
    {
      header: translations.headers.modelLabel,
      title: translations.headers.modelTitle,
      accessor: "model",
      colSpan: 4,
    },
    {
      header: translations.headers.rateLabel,
      title: translations.headers.rateTitle,
      accessor: "rate",
      colSpan: 5,
    },
    {
      header: translations.headers.distanceLabel,
      title: translations.headers.distanceTitle,
      accessor: "distance",
      colSpan: 4,
    },
    {
      header: translations.headers.amountForDistanceLabel,
      title: translations.headers.amountForDistanceTitle,
      accessor: "amountForDistance",
      colSpan: 5,
    },
    {
      header: translations.headers.sumOfBonusesLabel,
      title: translations.headers.sumOfBonusesTitle,
      accessor: "sumOfBonuses",
      colSpan: 5,
    },
    {
      header: translations.headers.sumOfPenaltiesLabel,
      title: translations.headers.sumOfPenaltiesTitle,
      accessor: "sumOfPenalties",
      colSpan: 5,
    },
    {
      header: translations.headers.amountForChargeHaltingsLabel,
      title: translations.headers.amountForChargeHaltingsTitle,
      accessor: "amountForChargeHaltings",
      colSpan: 6,
    },
    {
      header: translations.headers.amountForChargeHighwaysLabel,
      title: translations.headers.amountForChargeHighwaysTitle,
      accessor: "amountForChargeHighways",
      colSpan: 6,
    },
    {
      header: translations.headers.allContributionsAmountLabel,
      title: translations.headers.allContributionsAmountTitle,
      accessor: "allContributionsAmount",
      colSpan: 6,
    },
    {
      header: translations.headers.actions,
      title: translations.headers.actions,
      accessor: "actions",
      colSpan: 6,
    },
  ];

  return tableColumns;
};

const relatedBillingsTaxiTaxiHelper = {
  createTableColumns,
};

export default relatedBillingsTaxiTaxiHelper;
